import { Route } from "components/utils";
import { CarrierOrdersList } from "pages/logistics/carrierOrders/CarrierOrdersList";
import { NotFound } from "pages/notFound";
import { Redirect, RouteComponentProps, Switch } from "react-router-dom";

export const CarrierOrders = ({ match }: RouteComponentProps): JSX.Element => {
  return (
    <Switch>
      <Route
        exact={true}
        path={`${match.path}`}
        render={() => <Redirect to={`${match.path}/list/all`} />}
      />
      <Route
        exact={true}
        path={`${match.path}/list`}
        render={() => <Redirect to={`${match.path}/list/all`} />}
      />
      <Route
        component={CarrierOrdersList}
        exact={true}
        path={`${match.path}/list/all`}
        title="Milo - Logistyka - Zlecenia do przewoźnika"
      />
      <Route component={NotFound} exact={true} path="*" title="Milo" />
    </Switch>
  );
};
